import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "./components/MainLayout";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactsPage from "./pages/ContactsPage";
import ZombieCrushersPage from "./pages/ZombieCrushersPage";
import WarFrontPage from "./pages/WarFrontPage";
import GamesPage from "./pages/GamesPage";
import StorePage from "./pages/StorePage";
import AccountPage from "./pages/AccountPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SynapseInvitePage from "./pages/SynapseInvitePage";
import SearchPage from "./pages/SearchPage";
import LegalPage from "./pages/LegalPage";

import GhostHunterHome from "./components/ghosthunter/GhostHunterHome";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactsPage />} />
          <Route path="/contacts" element={<Navigate to="/contact" replace />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/games/zombie-crushers" element={<ZombieCrushersPage />} />
          <Route path="/games/warfront" element={<WarFrontPage />} />
          <Route path="/games/ghost-hunter" element={<GhostHunterHome />} />
          <Route path="/zombie-crushers" element={<Navigate to="/games/zombie-crushers" replace />} />
          <Route path="/warfront" element={<Navigate to="/games/warfront" replace />} />
          <Route path="/ghosthunter" element={<Navigate to="/games/ghost-hunter" replace />} />
          <Route path="/ghosthunter/about" element={<Navigate to="/games/ghost-hunter" replace />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/account" element={<AccountPage mode="login" />} />
          <Route path="/account/register" element={<AccountPage mode="register" />} />
          <Route path="/account/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/account/reset-password" element={<ResetPasswordPage />} />
          <Route path="/synapse/invite" element={<SynapseInvitePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/cookie-policy" element={<LegalPage type="cookies" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
